import React from 'react';
import { Link } from 'react-router-dom';
import { View, Text, Button, Flex } from '@aws-amplify/ui-react';
import { useReservationCancelClosePendingSummary } from '../hooks/useReservationCancelClosePendingSummary';

export default function Reservationcancelclosependingbanner({
  enabled = true,
  refreshKey = 0,
  fleetCode = null,
}) {
  const { totalPending, totalWarnings, byFleet } = useReservationCancelClosePendingSummary({
    enabled,
    refreshKey,
    fleetCode: fleetCode || undefined,
  });

  if (!enabled || (totalPending < 1 && totalWarnings < 1)) {
    return null;
  }

  return (
    <View
      style={{
        background: '#f0f7ff',
        border: '1px solid #4a90d9',
        borderRadius: 8,
        padding: '0.75rem 1rem',
        marginBottom: '1rem',
      }}
    >
      <Flex direction="row" justifyContent="space-between" alignItems="center" wrap="wrap" gap="0.5rem">
        <View>
          <Text fontWeight="bold">
            {totalPending > 0
              ? `${totalPending} reservation cancel/close proposal${totalPending === 1 ? '' : 's'} awaiting approval`
              : 'Reservation handoff warnings'}
            {totalWarnings > 0
              ? ` · ${totalWarnings} handoff warning${totalWarnings === 1 ? '' : 's'} (not actionable)`
              : ''}
          </Text>
          {byFleet.length > 1 ? (
            <Text fontSize="small" color="#666">
              {byFleet
                .map((f) => {
                  const parts = [];
                  if (f.pending_count) parts.push(`${f.pending_count} approve`);
                  if (f.warn_count) parts.push(`${f.warn_count} warn`);
                  return `${f.fleet_code}: ${parts.join(', ') || '0'}`;
                })
                .join(' · ')}
            </Text>
          ) : null}
        </View>
        {fleetCode ? (
          <Link
            to={`/reservation-cancel-close-review?fleets=${encodeURIComponent(fleetCode)}`}
          >
            <Button size="small">Review queue</Button>
          </Link>
        ) : null}
      </Flex>
    </View>
  );
}
